import { Ng2ImgMaxModule, Ng2ImgMaxService } from 'ng2-img-max';

import { CommonModule } from '@angular/common';
import { EditorModule } from '@tinymce/tinymce-angular';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RxRicheditComponent } from './rx-richedit.component';

@NgModule({
  imports: [CommonModule, FormsModule, EditorModule, Ng2ImgMaxModule, RxRicheditComponent],
  exports: [RxRicheditComponent],
})
export class RxRicheditModule {}
